
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightSearchlightOff as ObiLightSearchlightOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-searchlight-off.js';
 
 
 

 
 export const ObiLightSearchlightOff = createComponent({
   react: React,
   tagName: 'obi-light-searchlight-off',
   elementClass: ObiLightSearchlightOffElement,
   events: {
     
   }
  });
 
 